































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DiscIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { PolicyStatus } from 'admiral-core';
import 'dayjs/locale/de';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import PolicyStatusSelect from '@/components/common/selects/PolicyStatusSelect.vue';

@Component({
  name: 'policy-status-filter',
  components: {
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    DiscIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    PolicyStatusSelect,
  },
})
export default class PolicyStatusFilterComponent extends mixins(FilterMixin) {
  @Prop({ type: Array })
  selected!: PolicyStatus[];

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  updatePolicyStatus(val: PolicyStatus) {
    const status = val || [];
    this.$emit('update', Array.isArray(status) ? status : [status]);
  }
}
